<ng-container *transloco="let t">
  <main class="check">
    <header [attr.id]="waterNetworkData.title">
      <h3 [class.error]="!waterNetworkData.isPassed">
        {{ waterNetworkData.title }}
      </h3>
    </header>
    <section
      class="check-cases"
      [class.border]="waterNetworkData.isApplicable"
      [attr.id]="waterNetworkData.title"
    >
      <mat-slide-toggle
        [color]="waterNetworkData.isPassed ? 'primary' : 'warn'"
        [(ngModel)]="waterNetworkData.isApplicable"
        (change)="onChange()"
        *ngIf="!(readonly || printPreview)"
      >
        <span
          class="title"
          [class.error]="
            waterNetworkData.isApplicable && !waterNetworkData.isPassed
          "
          >{{ waterNetworkData.title }}</span
        >
      </mat-slide-toggle>
      <span
        class="title"
        [class.error]="
          waterNetworkData.isApplicable && !waterNetworkData.isPassed
        "
        *ngIf="readonly || printPreview"
        >{{ waterNetworkData.title }}
      </span>
      <div
        class="cases container"
        [style.margin-right]="readony || printPreview ? 0 : '35px'"
        *ngIf="waterNetworkData.isApplicable; else notApplicable"
      >
        <div *ngIf="printPreview">
          <mat-card
            class="mat-elevation-z4"
            *ngFor="let item of waterNetworkData.testData; let ind = index"
          >
            <mat-card-header>
              <mat-card-title
                >{{ t('inspection.fields.waterNetwork:test') }}
                {{ ind + 1 }}</mat-card-title
              >
            </mat-card-header>
            <mat-card-content>
              <ng-container
                *ngTemplateOutlet="formTpl; context: { item: item, ind: ind }"
              ></ng-container>
            </mat-card-content>
          </mat-card>
        </div>
        <mat-tab-group
          class="mat-elevation-z4"
          [(selectedIndex)]="selectedTab"
          *ngIf="!printPreview"
        >
          <mat-tab
            *ngFor="let item of waterNetworkData.testData; let ind = index"
          >
            <ng-template mat-tab-label>
              <mat-icon class="fail" color="warn" *ngIf="!item.isPassed">
                priority_high
              </mat-icon>
              <span
                >{{ t('inspection.fields.waterNetwork:test') }}
                {{ ind + 1 }}</span
              >
            </ng-template>
            <ng-template matTabContent>
              <div
                [style.margin-right]="readonly || printPreview ? '45px' : '0'"
              >
                <ng-container
                  *ngTemplateOutlet="formTpl; context: { item: item, ind: ind }"
                ></ng-container>
              </div>
              <button
                *ngIf="!(readonly || printPreview)"
                class="btn remove-btn"
                mat-raised-button
                aria-label="remove"
                [disabled]="waterNetworkData.testData.length === 1"
                (click)="removeTest()"
              >
                <span>{{ t('inspection.fields.plans:remove') }}</span>
              </button>
              <button
                *ngIf="!(readonly || printPreview)"
                class="btn add-btn"
                mat-raised-button
                color="accent"
                aria-label="add"
                (click)="addTest()"
              >
                <span>{{ t('inspection.fields.waterNetwork:addTest') }}</span>
              </button>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </section>
  </main>

  <ng-template #formTpl let-item="item" let-ind="ind">
    <authority-labs-check-case
      (dataChange)="onChange()"
      [printPreview]="printPreview"
      [readonly]="readonly"
      [inspection]="item"
      [allwaysApplicable]="true"
    >
      <section>
        <mat-form-field floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:testerName')
          }}</mat-label>
          <input
            type="text"
            matInput
            [placeholder]="t('inspection.fields.waterNetwork:testerName')"
            [drawableField]="'waterNetwork:' + ind + ':testerName'"
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:testerName')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.testerName"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
        </mat-form-field>

        <mat-form-field floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:testDateTime')
          }}</mat-label>
          <input
            type="text"
            matInput
            [placeholder]="t('inspection.fields.waterNetwork:testDateTime')"
            [drawableField]="'waterNetwork:' + ind + ':testDateTime'"
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:testDateTime')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.testDateTime"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
        </mat-form-field>

        <mat-form-field floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:pressureMeasurementLocation')
          }}</mat-label>
          <input
            type="text"
            matInput
            [placeholder]="
              t('inspection.fields.waterNetwork:pressureMeasurementLocation')
            "
            [drawableField]="
              'waterNetwork:' + ind + ':pressureMeasurementLocation'
            "
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:pressureMeasurementLocation')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.pressureMeasurementLocation"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
        </mat-form-field>

        <mat-form-field floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:flowMeasurementLocation')
          }}</mat-label>
          <input
            type="text"
            matInput
            [placeholder]="
              t('inspection.fields.waterNetwork:flowMeasurementLocation')
            "
            [drawableField]="'waterNetwork:' + ind + ':flowMeasurementLocation'"
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:flowMeasurementLocation')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.flowMeasurementLocation"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
        </mat-form-field>

        <mat-form-field floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:waterSupplyPipeDiameter')
          }}</mat-label>
          <input
            type="text"
            matInput
            [placeholder]="
              t('inspection.fields.waterNetwork:waterSupplyPipeDiameter')
            "
            [drawableField]="'waterNetwork:' + ind + ':waterSupplyPipeDiameter'"
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:waterSupplyPipeDiameter')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.waterSupplyPipeDiameter"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          />
        </mat-form-field>

        <mat-form-field class="numerical" floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:staticPressure')
          }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [drawableField]="'waterNetwork:' + ind + ':staticPressure'"
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:staticPressure')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.staticPressure"
            [readonly]="readonly || printPreview"
            (input)="onChartDataChange()"
          />
          <span class="prefix" matSuffix>psi</span>
        </mat-form-field>

        <mat-form-field class="numerical" floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:residualPressure')
          }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [drawableField]="'waterNetwork:' + ind + ':residualPressure'"
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:residualPressure')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.residualPressure"
            [readonly]="readonly || printPreview"
            (input)="onChartDataChange()"
          />
          <span class="prefix" matSuffix>psi</span>
        </mat-form-field>

        <mat-form-field class="numerical" floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:flowRate')
          }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [drawableField]="'waterNetwork:' + ind + ':flowRate'"
            [drawableFieldTitle]="t('inspection.fields.waterNetwork:flowRate')"
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.flowRate"
            [readonly]="readonly || printPreview"
            (input)="onChartDataChange()"
          />
          <span class="prefix" matSuffix>gpm</span>
        </mat-form-field>

        <mat-form-field class="numerical" floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:systemFlow')
          }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [drawableField]="'waterNetwork:' + ind + ':systemFlow'"
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:systemFlow')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.systemFlow"
            [readonly]="readonly || printPreview"
            (input)="onChartDataChange()"
          />
          <span class="prefix" matSuffix>gpm</span>
        </mat-form-field>

        <mat-form-field class="numerical" floatLabel="always" appearance="fill">
          <mat-label>{{
            t('inspection.fields.waterNetwork:systemDemand')
          }}</mat-label>
          <input
            type="number"
            min="0"
            matInput
            placeholder="0"
            [drawableField]="'waterNetwork:' + ind + ':systemDemand'"
            [drawableFieldTitle]="
              t('inspection.fields.waterNetwork:systemDemand')
            "
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.systemDemand"
            [readonly]="readonly || printPreview"
            (input)="onChartDataChange()"
          />
          <span class="prefix" matSuffix>psi</span>
        </mat-form-field>

        <br />

        <mat-form-field
          floatLabel="always"
          appearance="fill"
          style="width: 525px"
        >
          <mat-label>{{ t('inspection.fields.waterNetwork:type') }}</mat-label>
          <textarea
            matInput
            name="type"
            cdkTextareaAutosize
            [drawableField]="'waterNetwork:' + ind + ':type'"
            [drawableFieldTitle]="t('inspection.fields.waterNetwork:type')"
            [drawableFieldReadonly]="readonly"
            [(ngModel)]="item.type"
            [matAutocomplete]="auto"
            [readonly]="readonly || printPreview"
            (input)="onChange()"
          ></textarea>
          <div matSuffix class="note-btns" *ngIf="!readonly">
            <button
              mat-icon-button
              aria-label="notes-bank"
              color="primary"
              *ngIf="!(readonly || printPreview)"
              (click)="showNotesBank($event, item)"
            >
              <mat-icon>assignment</mat-icon>
            </button>
          </div>
        </mat-form-field>

        <br />

        <button
          class="btn"
          mat-raised-button
          aria-label="sync"
          *ngIf="!(readonly || printPreview)"
          (click)="syncStats(item)"
        >
          <span>{{ t('inspection.fields.waterNetwork:syncStats') }}</span>
        </button>

        <button
          class="btn"
          mat-raised-button
          aria-label="chart"
          *ngIf="!printPreview"
          (click)="showChart(item)"
        >
          <span>{{ t('inspection.fields.waterNetwork:showChart') }}</span>
        </button>
      </section>
      <mat-checkbox
        matSuffix
        [(ngModel)]="item.isApplicable"
        *ngIf="!(readonly || printPreview)"
        color="primary"
        style="margin-bottom: 10px"
        (change)="onChange()"
      >
        {{ t('inspection.fields.case:attachToCertificate') }}
      </mat-checkbox>
    </authority-labs-check-case>
  </ng-template>

  <ng-template #notApplicable>
    <mat-radio-group disabled="true" class="print-preview" *ngIf="printPreview">
      <mat-radio-button checked="false">{{
        t('inspection.fields.case:suitable')
      }}</mat-radio-button>
      <mat-radio-button checked="false">{{
        t('inspection.fields.case:notSuitable')
      }}</mat-radio-button>
      <mat-radio-button value="true" checked="true">{{
        t('inspection.fields.case:notApplicable')
      }}</mat-radio-button>
    </mat-radio-group>
  </ng-template>
</ng-container>
